module.exports = __webpack_public_path__ + "img/Icon-Biblio.8e87caef.svg";